// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","container":"App_container__Rt8T2","left":"App_left__yierV","right":"App_right__TxKjn","alert":"App_alert__C0lhs","title":"App_title__YS7Xx"};